export enum PaymentStep {
  METHODS = 'METHODS',
  CREDIT_CARDS = 'CREDIT_CARDS',
  PHONE_VERIFICATION = 'PHONE_VERIFICATION',
  VERIFICATION_CODE = 'VERIFICATION_CODE',
}
